import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import Colors from "../../../../utils/constants/colors";
import useColorScheme from "../../../../hooks/useColorScheme";
import { StyleSheet } from "react-native";
import { RootTabParamList, RootTabScreenProps } from "../../../../types";
import AdminDrawerNavigator from "./AdminDrawerNavigator";
import AdminHelpNavigator from "./AdminHelpNavigator";

export default function AdminTopTabNavigator({}) {
  const colorScheme = useColorScheme();
  const Tab = createMaterialTopTabNavigator<RootTabParamList>();

  return (
    <Tab.Navigator
      initialRouteName="AdminHome"
      screenOptions={{
        swipeEnabled: false,
        tabBarActiveTintColor: Colors[colorScheme].tint,
        tabBarIndicatorStyle: styles._tabBarIndicatorStyle,
        tabBarStyle: styles._tabBarStyle,
        tabBarLabelStyle: styles._tabBarLabelStyle,
        tabBarItemStyle: styles._tabBarItemStyle,
      }}
    >
      <Tab.Screen
        name="AdminHome"
        component={AdminDrawerNavigator}
        options={({}: RootTabScreenProps<"AdminHome">) => ({
          title: "Home",
        })}
      />
      <Tab.Screen
        name="AdminHelp"
        component={AdminHelpNavigator}
        options={({}: RootTabScreenProps<"AdminHelp">) => ({
          title: "Setting",
        })}
      />
    </Tab.Navigator>
  );
}

const styles = StyleSheet.create({
  _tabBarIndicatorStyle: {
    backgroundColor: "transparent", // Make indicator transparent
    height: 0, // Remove indicator height
  },
  _tabBarStyle: {
    height: 60,
    width: 0,
    alignSelf: "flex-end",
    // justifySelf: "center",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  _tabBarLabelStyle: {
    fontSize: 16,
    textTransform: "none",
  },
  _tabBarItemStyle: {
    width: 80,
  },
});
